import React from 'react'
import { View, Dimensions, StyleSheet } from 'react-native'
import NoSinsToken from "../../../../assets/svg/Token-NoSins.svg";
import PeoplePlanetToken from "../../../../assets/svg/Token-PeoplePlanet.svg";
import PlanetToken from "../../../../assets/svg/Token-Planet.svg";
import PlanetOverReturnsToken from "../../../../assets/svg/Token-PlanetOverReturns.svg";
import ReturnsOverPlanetToken from "../../../../assets/svg/Token-ReturnsOverPlanet.svg";
import PeopleOverReturnsToken from "../../../../assets/svg/Token-PeopleOverReturns.svg";
import ReturnsOverPeopleToken from "../../../../assets/svg/Token-ReturnsOverPeople.svg";
import BothOverReturnsToken from "../../../../assets/svg/Token-BothOverReturns.svg";
import ReturnsOverBothToken from "../../../../assets/svg/Token-ReturnsOverBoth.svg";
import PositiveImpactToken from "../../../../assets/svg/Token-PositiveImpact.svg";
import PeopleToken from "../../../../assets/svg/Token-People.svg";
import CarbonNeutralToken from "../../../../assets/svg/Token-CarbonNeutral.svg";
import AllToken from "../../../../assets/svg/Token-All.svg";
const actualWidth = Dimensions.get("screen").width;
export const DropBox = (props) => {
  return (
    <>
      {props.iconKey === "planet" && (
        <View style={styles.balls}>
          <img
            alt=""
            src={PlanetToken}
            style={{
              width: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              height: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              objectFit: "contain",
            }}
          />
        </View>
      )}
      {props.iconKey === "people" && (
        <View style={styles.balls}>
          <img
            alt=""
            src={PeopleToken}
            style={{
              width: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              height: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              objectFit: "contain",
            }}
          />
        </View>
      )}
      {props.iconKey === "planetandpeople" && (
        <View style={styles.balls}>
          <img
            alt=""
            src={PeoplePlanetToken}
            style={{
              width: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              height: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              objectFit: "contain",
            }}
          />
        </View>
      )}
      {props.iconKey === "planetmoney" && (
        <View style={styles.balls}>
          <img
            alt=""
            src={PlanetOverReturnsToken}
            style={{
              width: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              height: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              objectFit: "contain",
            }}
          />
        </View>
      )}
      {props.iconKey === "moneyplanet" && (
        <View style={styles.balls}>
          <img
            alt=""
            src={ReturnsOverPlanetToken}
            style={{
              width: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              height: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              objectFit: "contain",
            }}
          />
        </View>
      )}
      {props.iconKey === "positiveonly" && (
        <View style={styles.balls}>
          <img
            alt=""
            src={PositiveImpactToken}
            style={{
              width: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              height: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              objectFit: "contain",
            }}
          />
        </View>
      )}
      {props.iconKey === "carbonneutral" && (
        <View style={styles.balls}>
          <img
            alt=""
            src={CarbonNeutralToken}
            style={{
              width: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              height: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              objectFit: "contain",
            }}
          />
        </View>
      )}
      {props.iconKey === "screen" && (
        <View style={styles.balls}>
          <img
            alt=""
            src={NoSinsToken}
            style={{
              width: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              height: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              objectFit: "contain",
            }}
          />
        </View>
      )}
      {props.iconKey === "all" && (
        <View style={styles.balls}>
          <img
            alt=""
            src={AllToken}
            style={{
              width: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              height: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              objectFit: "contain",
            }}
          />
        </View>
      )}
      {props.iconKey === "peoplemoney" && (
        <View style={styles.balls}>
          <img
            alt=""
            src={PeopleOverReturnsToken}
            style={{
              width: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              height: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              objectFit: "contain",
            }}
          />
        </View>
      )}
      {props.iconKey === "moneypeople" && (
        <View style={styles.balls}>
          <img
            alt=""
            src={ReturnsOverPeopleToken}
            style={{
              width: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              height: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              objectFit: "contain",
            }}
          />
        </View>
      )}
      {props.iconKey === "bothmoney" && (
        <View style={styles.balls}>
          <img
            alt=""
            src={BothOverReturnsToken}
            style={{
              width: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              height: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              objectFit: "contain",
            }}
          />
        </View>
      )}
      {props.iconKey === "moneyboth" && (
        <View style={styles.balls}>
          <img
            alt=""
            src={ReturnsOverBothToken}
            style={{
              width: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              height: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
              objectFit: "contain",
            }}
          />
        </View>
      )}
    </>
  );
};
const styles = StyleSheet.create({
    balls: {
        width: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
        height: actualWidth > 700 ? 75 : actualWidth > 400 ? 62 : 62,
        borderRadius: actualWidth > 700 ? 38 : actualWidth > 400 ? 31 : 31,
        elevation: 4,
        backgroundColor: "transparent",
        alignItems: "center",
        justifyContent: "center",
        marginHorizontal: 10
    },
})